import { FC } from 'react';

import { Box } from '@mui/material';

import { SectionCard, TwoToggleRates } from '../../components';
import { CARDS } from '../TransactionPricing';

interface AdditionalTariffs {
    name: string;
    notAdminUser?: boolean;
}

export const ADDITIONAL_TARIFFS_PERSONAL_CARDS: CARDS[] = [
    { heading: 'Joining Fee', name: 'joiningFee' },
    {
        heading: 'Minimum Monthly Service Charge (per outlet*)',
        name: 'minMonthlyServiceFee',
        hardCodedToggle: true,
    },
    {
        heading: 'Authorisation Fee',
        name: 'authorisationFee',
        hardCodedToggle: true,
    },
    {
        heading: 'Non-Authorisation Fee',
        name: 'nonAuthorisationFee',
    },
    {
        heading: 'Chargeback Admin Fee (per Chargeback)',
        name: 'chargebackAdminFee',
    },
    {
        heading: 'Name & Address Check',
        name: 'nameAndAddressCheck',
    },
    {
        heading: 'Paper Statement Fee**',
        name: 'paperStatementFee',
    },
];

export const AdditionalTariffs: FC<AdditionalTariffs> = ({ name, notAdminUser }) => {
    return (
        <Box>
            <SectionCard heading="Personal Cards">
                {ADDITIONAL_TARIFFS_PERSONAL_CARDS.map((card, index) => {
                    return (
                        <TwoToggleRates
                            key={card.name}
                            namePrefix={`${name}.personalCards.${card.name}`}
                            heading={card.heading}
                            isOdd={index % 2 === 0}
                            hardCodedToggle
                            isConstant={card.isConstant || notAdminUser}
                        />
                    );
                })}
            </SectionCard>
        </Box>
    );
};
